/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollectionList = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsCollectionList = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height) {
      window.PXUTheme.applyMasonry();
    }
    
    this.createSlider();
    
  },
  createSlider: function() {

    let collectionListSlider = $('.collections-slider.slider-gallery');

    const slideData = {
      cellAlign: "center",
      wrapAround: true
    }

    $(collectionListSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: slideData.cellAlign,
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: true,
      //prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(collectionListSlider).on( 'settle.flickity', function() {
            $(collectionListSlider).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;